import(/* webpackMode: "eager" */ "/home/runner/work/tapcart-consumer-web/tapcart-consumer-web/apps/tapcart-ssr-app/app/global-error.tsx");
